import React from 'react';
import * as Constants from '../../Common/constants';
import { Container, Row, Col } from 'coolgrid';
import LIVELOGO from '../../images/live.png';
import SCOUTEYE from '../../images/scout-image.png';



export default class TournamentItem extends React.Component {
    constructor(props) {

        super(props);

        this.state = {};

    }

    render() {
        let fromdateStr = this.props.data.fromDate.split('T')[0];

        let scoutImgSrc = Constants.IMAGE_SERVER + "/images/scout-image3.png";
        let flagImg = Constants.IMAGE_SERVER + "/images/flags/flag_" + this.props.data.country + ".jpg";
        if (flagImg == "" || flagImg == undefined) {
            flagImg = Constants.IMAGE_SERVER + "/images/golf_ball.jpg";
        }
        if (this.props.data.state == "DEMO") {
            flagImg = Constants.IMAGE_SERVER + "/images/golf_ball.jpg";
        }
        return (


            <div className='tournamentitem' onClick={() => this.props.onclick(this.props.data)}>
                {this.props.data.state == "POSTPONED" && <div style={{ justifyContent: 'flex-end', float: 'right', marginRight: '3px', marginLeft: '5px', color: '#e0c06f', fontSize: '0.7em' }}> POSTPONED</div>}
                {this.props.data.coverage > 0 && this.props.data.state != "POSTPONED" && <div className="scoutImage"> <img id='imgsc' style={{ justifyContent: 'flex-end', width: '1.8em', float: 'right', marginRight: '3px', marginLeft: '10px' }} src={scoutImgSrc}></img></div>}
                <div><img style={{ borderRadius: '50%', width: '30px', float: 'left', marginRight: '10px' }} src={flagImg} /></div>

                <span id="isscouted">This tournament has Scout Coverage </span>

                <div style={{ display: 'flex' }}>
                    <span style={{ justifyContent: 'flex-start', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{this.props.data.name}</span>
                </div>
                <span className='tournamentitemTime'>{fromdateStr}</span>
            </div>


        );

    }


}
//{this.props.data.coverage > 0 && <span style={{justifyContent: 'flex-end' }} className='tournamentcoverage'>scout</span>}
function toDate(mydate) {
    var mm = mydate.getMonth() + 1; // getMonth() is zero-based
    var dd = mydate.getDate();

    return [mydate.getFullYear(),
    (mm > 9 ? '' : '0') + mm,
    (dd > 9 ? '' : '0') + dd
    ].join('-');
};




// WEBPACK FOOTER //
// ./src/Components/TournamentsPage/TournamentItem.js